var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-cell"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.previewProject()}}},[_vm._v(_vm._s(_vm.data.projectId))])])}
var staticRenderFns = []

export { render, staticRenderFns }